// tutorial: qui registriamo tutti i filtri di Vue
// ad esempio il filtro currency ci permette di formattare un numero in valuta {{ item.price | currency }}
import currency from './currency';
import street from './street';
import region from './region';
import date from './date';
import country from './country';
import nodecimals from './nodecimals';
import weekdays from './weekdays';

const FiltersPlugin = {
    install(Vue: any) {
        Vue.filter('currency', currency);
        Vue.filter('street', street);
        Vue.filter('region', region);
        Vue.filter('date', date);
        Vue.filter('country', country);
        Vue.filter('nodecimals', nodecimals);
        Vue.filter('weekdays', weekdays);
    },
};

export default FiltersPlugin;
